import { type JSX } from 'react/jsx-runtime';

export const JsmWorkRequestsLightIcon = (): JSX.Element => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="2" y="2" width="20" height="20" rx="4" fill="#EED7FC" />
		<path
			d="M6.59 6.592V15.4h8.808V6.592zm3.775 1.891h3.145v.944h-3.145zm0 2.04h3.145v.944h-3.145zM8.794 8.32c.346 0 .629.283.629.629s-.283.63-.63.63a.63.63 0 0 1 0-1.26m0 2.046a.63.63 0 1 1-.002 1.26.63.63 0 0 1 .002-1.26"
			fill="#1868DB"
		/>
		<path d="M16.594 12.025v1.46h-6.23v2.97h6.23v1.753l3.09-3.093z" fill="#BF63F3" />
		<path d="M10.365 13.485V15.4h5.033v-1.915z" fill="#09326C" />
	</svg>
);
